module.exports = __webpack_public_path__ + "img/characters.34619fb6.png";